<table #table class="grid-table">
  @for (row of items | chunk: columns; track row; let i = $index) {
    <tr>
      @for (item of row; track item; let j = $index) {
        <td
          cmMenuGridCell
          [item]="item"
          [tileWidth]="tileWidth"
          [tileHeight]="tileHeight"
        ></td>
      }
    </tr>
  }
</table>
